import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';
import { OutputSetting } from 'icreate/common/models/output-settings';

@Injectable({
    providedIn: 'root',
})
export class OutputSettingsService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    getSlotTileArray(slot, selectedSetting?: OutputSetting) {
        if (!slot) return [];
        const titleArray = [];
        titleArray.push(`FCU ${slot.fcuNum}`);
        titleArray.push(`-`);
        if (slot.fuNum) {
            titleArray.push(`FU ${slot.fuNum}`);
            titleArray.push(`-`);
        }
        titleArray.push(`Slot ${this.paddNumber(slot.no)}`);
        if (selectedSetting) {
            titleArray.push(`-`);
            titleArray.push(`Terminal ${this.paddNumber(selectedSetting.terminalNum)} (DO)`);
        }

        return titleArray;
    }

    paddNumber(number: number) {
        return number.toString().padStart(2, '0');
    }

    async getAllDOTerminals(slotId): Promise<OutputSetting[]> {
        return await lastValueFrom(
            this.http.get<OutputSetting[]>(`${this.domain}/api/ouput-settings/DO`, {
                params: { slotId },
            })
        );
    }

    async getAllAOTerminals(slotId): Promise<OutputSetting[]> {
        return await lastValueFrom(
            this.http.get<OutputSetting[]>(`${this.domain}/api/ouput-settings/AO`, {
                params: { slotId },
            })
        );
    }

    async saveAOTerminals(settings: OutputSetting[], vesselId: string): Promise<void> {
        return await lastValueFrom(this.http.put<void>(`${this.domain}/api/ouput-settings/AO`, { settings, vesselId }));
    }

    async saveDOTerminals(settings: OutputSetting, vesselId: string): Promise<{ settingId: string }> {
        return await lastValueFrom(
            this.http.put<{ settingId: string }>(`${this.domain}/api/ouput-settings/DO`, {
                settings,
                vesselId,
            })
        );
    }

    async deleteDOTerminals(slotId: string, terminalNums: number[], vesselId: string): Promise<void> {
        return await lastValueFrom(
            this.http.delete<void>(`${this.domain}/api/ouput-settings/DO`, {
                body: { terminalNums },
                params: { vesselId, slotId },
            })
        );
    }
}
